/* 
 公共方法
 */

class util {
	//深拷贝
	deepCopy(obj){
		var str, newobj = obj.constructor === Array ? [] : {};
		if (typeof obj !== 'object') {
			return;
		} else if (window.JSON) {
			str = JSON.stringify(obj); //系列化对象
			newobj = JSON.parse(str); //还原
		} else {
			for (var i in obj) {
				if (obj.hasOwnProperty(i)) {
					newobj[i] = typeof obj[i] === 'object' ?
						cloneObj(obj[i]) : obj[i];
				}
			}
		}
		return newobj;
	}
	//判断是不是移动端
	isMobile(){
		var userAgentInfo = navigator.userAgent;
		var Agents = ["Android", "iPhone",
					"SymbianOS", "Windows Phone",
					"iPad", "iPod"];
		var flag = false;
		
		for (var v = 0; v < Agents.length; v++) {
			if (userAgentInfo.indexOf(Agents[v]) > -1) {
				flag = true;
				break;
			}
		}
		
		return flag;
	}
}

export default new util()



// WEBPACK FOOTER //
// ./src/utils/utils.js